import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { addToCart } from "../../features/cart/cartSlice";

import styles from "./addToCart.module.css";

function AddToCart(props) {
  const { product } = props;
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    var newCartItem = {
      ...product,
      quantity,
    };
    dispatch(addToCart(newCartItem));
  };

  const handleQuantityChange = (value) => {
    if (value > 0 && value < 100) {
      setQuantity(value);
    }
  };

  return (
    <>
      <input
        type="number"
        value={quantity}
        onChange={(e) => handleQuantityChange(e.target.value)}
        className={styles.input}
      />
      <Button variant="primary" onClick={handleAddToCart}>
        Add to Cart
      </Button>
    </>
  );
}

export default AddToCart;
